// Real customer contacts are used everywhere by default. The shared dev test
// contact is opt-in: callers pass useTestContact to redirect a lookup to it so
// the integration can be exercised without touching a real customer. LIVE never
// redirects, regardless of the flag.
const DEV_TEST_CONTACT_EMAIL = 'mattmyersmusic@gmail.com';

export type ResolveCrmContactEmailParams = {
	realEmail: string;
	environment?: string;
	useTestContact?: boolean;
};

export const resolveCrmContactEmail = (params: ResolveCrmContactEmailParams): string => {
	const { realEmail, environment, useTestContact = false } = params;
	return useTestContact && environment !== 'LIVE' ? DEV_TEST_CONTACT_EMAIL : realEmail;
};
